import {Component, ViewChild} from '@angular/core';
import {BaseState, GenericListEntity, Media} from "@base/entities/BaseEntities";
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService} from "@base/component/ServiceBag";
import {DemoSimpleDialogComponent} from "@ui/demo/components/dialogs/simple-dialog/demo-simple-dialog.component";
import {BarcodeBoxDialogComponent} from "@ui/dialogs/barcodebox-dialog/barcodeboxdialog.component";
import {FileBoxDialogComponent} from "@ui/dialogs/filebox-dialog/fileboxdialog.component";
import {HtmlBoxDialogComponent} from "@ui/dialogs/htmlbox-dialog/htmlbox-dialog.component";
import {ImageBoxDialogComponent} from "@ui/dialogs/imagebox-dialog/imageboxdialog.component";
import {InputBoxDialogComponent} from "@ui/dialogs/inputbox-dialog/inputboxdialog.component";
import {EnumFileBoxReturnDataTypes, EnumInputBoxTypes, EnumMessageBoxTypes} from "@core/framework/sysenums.enum";
import {MessageBoxDialogComponent} from "@ui/dialogs/messagebox-dialog/messageboxdialog.component";
import {PhotoBoxDialogComponent} from "@ui/dialogs/photobox-dialog/photoboxdialog.component";
import {PreviewDialogComponent} from "@ui/dialogs/preview-dialog/previewdialog.component";
import {SelectBoxDialogComponent} from "@ui/dialogs/selectbox-dialog/selectboxdialog.component";
import {SignBoxDialogComponent} from "@ui/dialogs/signbox-dialog/signboxdialog.component";

class State extends BaseState {
    HTMLBody: string;
    SelectOptions: GenericListEntity[];
}

@Component({
    selector: 'app-demo-dialogs',
    templateUrl: './demo-dialogs.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoDialogsComponent extends BaseComponent<State> {

    @ViewChild(DemoSimpleDialogComponent) simpleDialog: DemoSimpleDialogComponent;
    @ViewChild(BarcodeBoxDialogComponent) barcodeBoxDialog: BarcodeBoxDialogComponent;
    @ViewChild(FileBoxDialogComponent) fileBoxDialog: FileBoxDialogComponent;
    @ViewChild(HtmlBoxDialogComponent) htmlBoxDialog: HtmlBoxDialogComponent;
    @ViewChild(ImageBoxDialogComponent) imageBoxDialog: ImageBoxDialogComponent;
    @ViewChild(InputBoxDialogComponent) inputBoxDialog: InputBoxDialogComponent;
    @ViewChild(MessageBoxDialogComponent) messageBoxDialog: MessageBoxDialogComponent;
    @ViewChild(PhotoBoxDialogComponent) photoBoxDialog: PhotoBoxDialogComponent;
    @ViewChild(PreviewDialogComponent) previewDialog: PreviewDialogComponent;
    @ViewChild(SelectBoxDialogComponent) selectBoxDialog: SelectBoxDialogComponent;
    @ViewChild(SignBoxDialogComponent) signBoxDialog: SignBoxDialogComponent;
    
    constructor(A: ServiceBagService) {
        super(A, 'DemoDialogsComponent', State);
    }
    
    override OnInitComponent() {
        this.State.HTMLBody = "Html content";
        this.State.SelectOptions = this.GetSelectBoxDialogOptions();
    }

    public OpenSimpleDialog() {
        this.simpleDialog.ShowDialogShort((_) => console.log('Simple Dialog closed'));
    }
    
    public OpenBarcodeBoxDialog() {
        this.barcodeBoxDialog.ShowDialogShort((_) => console.log('Barcode Box Dialog closed'))
    }
    
    public OnTextDecoded(event) {
        console.log('On text decoded');
        console.log(event);
    }

    public OnResultDecoded(event) {
        console.log('On result decoded');
        console.log(event);
    }

    public OpenFileBoxDialog() {
        this.fileBoxDialog.ReturnDataType = EnumFileBoxReturnDataTypes.FileList;
        this.fileBoxDialog.ShowDialog((list: File[]) => {
            console.log("File Box Dialog closed");
            console.log(list);
        });
    }
    
    public OpenHtmlBoxDialog() {
        this.htmlBoxDialog.ShowDialogShort((state: any) => {
            console.log("Html Box Dialog closed");
            console.log(state.HTMLBody);
            this.State.HTMLBody = state.HTMLBody;
        });
    }

    public OpenImageBoxDialog() {
        this.imageBoxDialog.ImageSource = 'https://i.pinimg.com/originals/8e/19/19/8e19199e990ba486fe79426a560c1b84.jpg';
        this.imageBoxDialog.ShowDialogShort(() => { 
            console.log('Image Box Dialog closed');
        });
    }
    
    public CloseImageBoxDialog() {
        this.imageBoxDialog.CloseDialogWithSuccess();
    }
    
    public OpenInputBoxDialog() {
        this.inputBoxDialog.FieldLabel = "Field label";
        this.inputBoxDialog.Prompt = "Field prompt";
        this.inputBoxDialog.Type = EnumInputBoxTypes.Number;
        
        this.inputBoxDialog.ShowDialogShort((value: number) => {
            console.log('Input Box Dialog closed. Value: ' + value);
        });
    }
    
    public OpenMessageBoxDialog() {
        this.messageBoxDialog.Prompt = "Prompt message";
        this.messageBoxDialog.Type = EnumMessageBoxTypes.YesNo;
        this.messageBoxDialog.ShowDialogShort((e) => {
            console.log("Message Box Dialog closed with success");
        }, () => {
            console.log("Message Box Dialog closed with failure");
        });
    }
    
    public OpenPhotoBoxDialog() {
        this.photoBoxDialog.ShowDialogShort((data: Media[]) => {
            console.log('Photo Box Dialog closed');
            console.log(data);
        });
    }
    
    public OpenPreviewDialog() {
        this.previewDialog.Url = 'https://www.microsoft.com/uk-ua/';
        this.previewDialog.ShowDialogShort(() => {
            console.log('Preview Dialog closed');
        });
    }
    
    public OpenSelectBoxDialog() {
        this.selectBoxDialog.ShowDialogShort((result) => {
            console.log(result);
        });
    }
    
    private GetSelectBoxDialogOptions(): GenericListEntity[] {
        return [
            {
                EntryID: 1,
                Text: "Option 1",
                Value: "Value 1",
                Description: "Description 1"
            },
            {
                EntryID: 2,
                Text: "Option 2",
                Value: "Value 2",
                Description: "Description 2"
            }
        ];
    }
    
    public OpenSignBoxDialog() {
        this.signBoxDialog.ShowDialogShort((signature) => {
            console.log('Sign Box Dialog closed');
            console.log(signature);
        });
    }
}
